// Group by Team
export const ROLLOUTS = {
    // Hawks
    HAWKS_AI_STORE_BUILDER_ENTRY_POINTS: 'hawks_ai_store_builder_entry_points',

    // Crows
    CROWS_PRO_CATALOG_NO_RESULTS: 'crows_pro_catalog_no_results_rollout',
    CROWS_AI_DIRECTOR_BANNER: 'crows_ai_director_banner',
    CROWS_MP_BFF_EXPANSION: 'crows_mp_bff_expansion',
    CROWS_PYTHONS_AGENTIC_BRIEFS: 'crows_pythons_agentic_briefs',
    CROWS_SSR_GIG_COUNT: 'crows_ssr_gig_count',
    CROWS_FILTERS_MODAL: 'crows_filters_modal',
    CROWS_CLEAN_GIG_CARD_URL: 'crows_clean_gig_card_url',
    CROWS_HIDE_SERVICE_INCLUDES: 'crows_hide_service_includes',
    CROWS_DEFAULT_GIG_PRICE_DISPLAY: 'crows_default_gig_price_display',
    CROWS_DEFAULT_GIG_PRICE_DISPLAY_KILL_SWITCH: 'crows_default_gig_price_display_kill_switch',

    // Pythons
    PYTHONS_MIRA_ENTRY_POINTS: 'pythons_mira_entry_points',

    // TODO Group By Team and cleanup
    VIPERS_BRIEF_AND_MATCH_MODAL: 'vipers_brief_and_match_modal',
    HAWKS_LISTINGS_SIDE_FILTERS: 'hawks_listings_side_filters',
    CARIBOU_RATING_SCORE_UPDATES: 'caribou_rating_score_updates',
    // cheetahs
    CHEETAHS_BOOK_PUBLISHING: 'cheetahs_book_publishing',
    CHEETAHS_BOOK_PUBLISHING_ALLOCATION_GUARD: 'cheetahs_book_publishing_allocation_guard',

    // dolphins
    DOLPHINS_HOURLY_RATE_BANNER_LISTINGS_GUEST: 'dolphins_hourly_rate_banner_listings_guest',

    // meerkats
    MEERKATS_LISTINGS_AGGREGATE_RATING: 'meerkats_listings_aggregate_rating',

    // cobras
    COBRAS_PUBLIC_RATING_VARIANCE: 'cobras_public_rating_variance',
};
